import { BannerType } from '../../banner.types';

export function canDismissBanner(banner: BannerType) {
  if (banner === BannerType.SWITCH_CALL || banner === BannerType.MIC_PERMISSION) return false;
  return true;
}
